import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';

import { StatisticsHeader } from '../models/statistics-header.model';
import { BaseService } from './base.service';
import { catchError } from 'rxjs/operators';

@Injectable()
export class StatisticsService {
  private statisticsSource = new Subject();
  statisticsSource$ = this.statisticsSource.asObservable();
  constructor(private httpClient: HttpClient, private baseService: BaseService) { }
  getStatisticsHeader(id: string): Observable<StatisticsHeader> {
    const url = `${this.baseService.hostDomain}/api/productionstatistics`;
    return this.httpClient.post<StatisticsHeader>(url, {
      editionId: id
    }).pipe(
      catchError(err => {
        this.baseService.handleError(err, 'Obteniendo estadísticas');
        return [];
      })
    );
  }
  refreshStatistics() {
    this.statisticsSource.next();
  }
}
